// extracted by mini-css-extract-plugin
module.exports = {"container":"TakeoverReceiverConfirmationCheckbox_container__1gqVF","checkboxContainer":"TakeoverReceiverConfirmationCheckbox_checkboxContainer__zOBZS"};